import ProblemDetailsError from '../api/ProblemDetailsError';
import isProblemDetails from './isProblemDetails';
import isAuthError from './isAuthError';
import {problemErrorMessages} from './problemErrors';
import {ProblemDetails} from '../types';

function problemDetailsToString(problemDetails: ProblemDetails): string {
    // Service validation errors carry the message the user needs; the generic title
    // ("There were errors with your request.") adds nothing.
    const messages: string[] = problemErrorMessages(problemDetails);

    if (messages.length === 0) {
        if (problemDetails.title) {
            messages.push(problemDetails.title);
        }

        if (problemDetails.detail) {
            messages.push(problemDetails.detail);
        }
    }

    return messages.join(' ') || 'An unexpected error occurred.';
}

export default function unknownErrorToString(err: unknown): string {
    if (err === null || err === undefined) {
        return '';
    }

    if (typeof err === 'string') {
        return err;
    }

    if (err instanceof ProblemDetailsError) {
        return problemDetailsToString(err.problemDetails);
    }

    if (err instanceof Error) {
        return err.message;
    }

    if (isProblemDetails(err)) {
        return problemDetailsToString(err);
    }

    if (isAuthError(err)) {
        return `${err.error}: ${err.error_description}`;
    }

    if (typeof err === 'object' && 'message' in err) {
        return String(
            (err as {message: unknown}).message ?? 'An error occurred.'
        );
    }

    try {
        return JSON.stringify(err);
    } catch {
        return 'An unexpected error occurred.';
    }
}
